import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import People from '../../../services/hammurabi/people';
import PchPaper from '../../../../pch/components/PchPaper/PchPaper';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

function VerifyEmail() {
	const { user } = useSelector(({ auth }) => auth);
	const { getIdTokenClaims } = useAuth0();
	const resendEmail = async () => {
		if (user) {
			try {
				const claims = await getIdTokenClaims();
				let response = await People.resendEmail(user.auth_id, claims?.__raw);
				toast.success(response.message);
			} catch (error) {
				toast.error('There was an error sending the email, please try again');
			}
		}
	};

	return (
		<PchPaper>
			<div className='grid gap-y-2 justify-items-center text-center w-full'>
				<img className='w-24' src='assets/img/email-verification.png' alt='verify email' />
				<div className='text-4xl font-bold'>Please verify your email</div>
				<p className='px-40'>
					Check your inbox (or Spam folder) and look for an email from SimplyBorrowed's Customer Portal to verify
					your address. If you have not received it, please click{' '}
					<span className='underline cursor-pointer' onClick={resendEmail}>
						here
					</span>{' '}
					to send it again
				</p>
			</div>
		</PchPaper>
	);
}

export default VerifyEmail;
